var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    style: {
      enableBackground: "new 0 0 1417.3 1417.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000000195549706946085620000002343702029732139958_);}\n\t.st1{fill:#F7B710;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 69.5,
    y: 647.1,
    width: 1276.9,
    height: 125.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085970727351744151870000008453197656060685963_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2844",
    style: {
      clipPath: "url(#SVGID_00000085970727351744151870000008453197656060685963_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19107",
    className: "st1",
    d: "M85.5,772.4c315-56.8,638.9-81.6,958.6-65.9c91.7,4.5,183.6,10.7,275,19.7 c32.8,3.3,37.7-46.5,5.1-50.8c-322.2-42.9-651.8-35.7-973,12.9c-91,13.8-180.8,34-270.2,55.7C63.3,748.3,67,775.7,85.5,772.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrait);
export default __webpack_public_path__ + "static/media/trait.86a2007010979fad6f82a482c4cd61dd.svg";
export { ForwardRef as ReactComponent };